export const getUserData = () => {
  let user = localStorage.getItem("user_data");
  if (user) {
    return JSON.parse(user);
  }
  return null;
};

export const setUserData = (value) => {
  localStorage.setItem("user_data", JSON.stringify(value));
};
export const removeUserData = () => localStorage.removeItem("user_data");
